const SET_DEV_LOGIN_CREDENTIALS = 'devLogin/SET_CREDENTIALS';

interface DevLoginState {
	email: string | null;
	password: string | null;
	redirectUri: string | null;
}

interface SetCredentialsAction {
	type: typeof SET_DEV_LOGIN_CREDENTIALS;
	email: string;
	password: string;
	redirectUri: string;
}

const initialState: DevLoginState = {
	email: null,
	password: null,
	redirectUri: null,
};

export const setDevLoginCredentials = (
	email: string,
	password: string,
	redirectUri: string,
): SetCredentialsAction => ({
	type: SET_DEV_LOGIN_CREDENTIALS,
	email,
	password,
	redirectUri,
});

type ReducerAction = SetCredentialsAction | { type: string };

const reducer = (
	state: DevLoginState = initialState,
	action: ReducerAction = { type: '' },
) => {
	switch (action.type) {
		case SET_DEV_LOGIN_CREDENTIALS: {
			const { email, password, redirectUri } = action as SetCredentialsAction;
			return { email, password, redirectUri };
		}
		default:
			return state;
	}
};

export default reducer;
